import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import { AuthService, tokenEndpoint } from '../auth/auth.service';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
  constructor(private authService: AuthService) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (!this.authService.isApiUrl(request.url) || request.url.includes(tokenEndpoint) ||
        request.url.includes('TenantConfiguration/GetNetwork')) {
      return next.handle(request);
    }
    return next.handle(this.addAuthenticationToken(request)).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status !== 401 || !this.authService.tokenData) return throwError(error);
        return this.authService.refreshToken().pipe(
          catchError(refreshError => {
            this.authService.logout();
            return throwError(refreshError);
          }),
          switchMap(() => next.handle(this.addAuthenticationToken(request)))
        );
      })
    );
  }

  private addAuthenticationToken(request: HttpRequest<any>): HttpRequest<any> {
    const token = this.authService.tokenData?.access_token;
    return token ? request.clone({ setHeaders: { Authorization: `Bearer ${token}` } }) : request;
  }
}
